import { useState } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import ProcessSection from './components/ProcessSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import QuoteModal from './components/QuoteModal';
import ConsultationModal from './components/ConsultationModal';
import AuditModal from './components/AuditModal';

export default function Home() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const [isConsultationModalOpen, setIsConsultationModalOpen] = useState(false);
  const [isAuditModalOpen, setIsAuditModalOpen] = useState(false);

  const openQuoteModal = () => setIsQuoteModalOpen(true);
  const closeQuoteModal = () => setIsQuoteModalOpen(false);
  
  const openConsultationModal = () => setIsConsultationModalOpen(true);
  const closeConsultationModal = () => setIsConsultationModalOpen(false);

  const openAuditModal = () => setIsAuditModalOpen(true);
  const closeAuditModal = () => setIsAuditModalOpen(false);

  return (
    <div className="min-h-screen bg-white">
      <Header onOpenQuoteModal={openQuoteModal} />
      <HeroSection onOpenQuoteModal={openQuoteModal} onOpenConsultationModal={openConsultationModal} />
      <ServicesSection onOpenAuditModal={openAuditModal} />
      <WhyChooseUsSection onOpenConsultationModal={openConsultationModal} />
      <ProcessSection onOpenAuditModal={openAuditModal} />
      <TestimonialsSection />
      <CTASection onOpenQuoteModal={openQuoteModal} onOpenConsultationModal={openConsultationModal} />
      <Footer />
      <QuoteModal isOpen={isQuoteModalOpen} onClose={closeQuoteModal} />
      <ConsultationModal isOpen={isConsultationModalOpen} onClose={closeConsultationModal} />
      <AuditModal isOpen={isAuditModalOpen} onClose={closeAuditModal} />
    </div>
  );
}
